export default class Transaction {
  static TYPES = {
    EARN: { value: "earn", label: "Ganho" },
    REDEEM: { value: "redeem", label: "Resgate" },
    ADJUST: { value: "adjust", label: "Ajuste Manual" },
  };

  static SOURCES = {
    MANUAL: { value: "manual", label: "Operador" },
    PURCHASE: { value: "purchase", label: "Compras" },
    GIFT_CARD: { value: "giftCard", label: "Cartão Vale-Presente" },
    COUPON: { value: "coupon", label: "Cupom" },
  };

  static getSourceLabel(source) {
    const { label } = Object.values(this.SOURCES).find(
      (i) => i.value === source,
    );

    return label;
  }

  static getTypeLabel(type) {
    const { label } = Object.values(this.TYPES).find((i) => i.value === type);

    return label;
  }

  static validate(transaction, balance) {
    const {
      amount: nAmount,
      description,
      type,
      source,
      multiplier,
    } = transaction;

    if (Number(nAmount) < 0) return false;

    const amount = Math.abs(Number(nAmount)) * multiplier;

    return (
      amount !== 0 &&
      description.length &&
      type &&
      source &&
      balance + amount >= 0
    );
  }
}
